<template>
    <div class="mt-6">
        <div class="redesign-table">
            <div class="table-wrapper">
                <div class="row is-header level mb-0">
                    <div class="level-left">
                        <h2 class="level-item">Portal-Logo</h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="level mt-3">
            <div class="level-left">
                <div class="level-item">
                    <img
                        v-if="item && item.portalLogo"
                        :src="item.portalLogo"
                        alt="Portal-Logo"
                        style="max-height: 80px; max-width: 240px;"
                    />
                    <span v-else class="has-text-grey">Kein Logo — es wird das Standard-Logo verwendet.</span>
                </div>
            </div>
            <div class="level-left">
                <input
                    type="file"
                    ref="file"
                    accept="image/*"
                    style="display: none"
                    @change="onFileChange($event.target.files)"
                />
                <button
                    class="button is-primary level-item"
                    :class="{ 'is-loading': isUploading }"
                    @click.prevent="$refs.file.click()"
                >
                    <i class="material-icons">photo</i>&nbsp;Logo hochladen
                </button>
                <button
                    v-if="item && item.portalLogo"
                    class="button level-item"
                    :disabled="isUploading"
                    @click.prevent="removeLogo"
                >Entfernen</button>
            </div>
        </div>
        <p class="help">Wird im Kopf des Kundenportals für die Portal-Zugänge dieses Kunden angezeigt. Ohne Logo wird das Standard-Logo verwendet.</p>
    </div>
</template>

<script>
import axios from 'axios';
import Mixin from '../tab';
import { notifySuccess, notifyError } from '@components/Notification';

// Avatar-style upload (see ApiImageController): saves straight into the public
// folder under a per-client filename and returns the /files/... publicPath.
const LOGO_FOLDER = 'public/clientSpecific/client_logos';

export default {
    mixins: [Mixin],

    data() {
        return {
            isUploading: false,
        };
    },

    methods: {
        onFileChange(files) {
            if (!files || !files.length || !this.item || !this.item.id) {
                return;
            }
            const file = files[0];
            if (!file.type.match('image.*')) {
                notifyError('Bitte eine Bilddatei wählen');
                return;
            }

            const ext = file.name.includes('.') ? file.name.split('.').pop() : 'png';
            const formData = new FormData();
            formData.append('user_file_upload', file);
            formData.append('customFolder', LOGO_FOLDER);
            // Unique filename per upload → the image URL changes, so no stale cache.
            formData.append('customFilename', `${this.item.id}-${Date.now()}.${ext}`);
            formData.append('title', `client-${this.item.id}-portal-logo`);

            this.isUploading = true;
            axios.post('/api/images/upload', formData)
                .then((response) => {
                    // Store the web-root URL (public/ is the web root, served at /),
                    // matching how the default logo is served — so it loads for the
                    // portal without the /files alias' auth context.
                    const path = (response.data && response.data.path) || '';
                    this.saveLogo('/' + path.replace(/^public\//, ''));
                })
                .catch(() => {
                    this.isUploading = false;
                    notifyError('Logo konnte nicht hochgeladen werden');
                });
        },

        saveLogo(path) {
            axios.put(`/api/clients/${this.item.id}`, { portalLogo: path })
                .then(() => {
                    this.$set(this.item, 'portalLogo', path);
                    notifySuccess('Portal-Logo gespeichert');
                })
                .catch(() => notifyError('Logo konnte nicht gespeichert werden'))
                .then(() => { this.isUploading = false; });
        },

        removeLogo() {
            axios.put(`/api/clients/${this.item.id}`, { portalLogo: null })
                .then(() => {
                    this.$set(this.item, 'portalLogo', null);
                    notifySuccess('Portal-Logo entfernt');
                })
                .catch(() => notifyError('Logo konnte nicht entfernt werden'));
        },
    },
};
</script>
